import PropTypes from "prop-types";

import { ModalButton } from "../../ModalButton";

const CreditScore = (props) => {
	const { setMediaAlphaState, isLastStep } = props;

	const updateState = (val) => {
		setMediaAlphaState({ credit_rating: val }, isLastStep);
	};

	return (
		<div className="tw-mb-8 tw-mt-4">
			<div className="tw-mb-8 tw-text-center tw-font-semibold tw-leading-5 tw-text-black">
				Please estimate your credit score:
			</div>
			<div className="tw-mb-4 tw-flex tw-justify-between tw-gap-5">
				<ModalButton
					className="tw-w-full tw-pl-[30px] tw-pr-[30px] sm:tw-pl-[35px] sm:tw-pr-[35px]"
					onPress={() => updateState("Poor")}
				>
					Poor
				</ModalButton>
				<ModalButton
					className="tw-w-full tw-pl-[30px] tw-pr-[30px] sm:tw-pl-[35px] sm:tw-pr-[35px]"
					onPress={() => updateState("Average")}
				>
					Average
				</ModalButton>
			</div>
			<div className="tw-mb-4 tw-flex tw-justify-between tw-gap-5">
				<ModalButton
					className="tw-w-full tw-border-2 tw-border-solid tw-border-[#1774ff] tw-pl-[20px] tw-pr-[20px] sm:tw-pl-[35px] sm:tw-pr-[35px]"
					onPress={() => updateState("Good")}
				>
					Good
				</ModalButton>
				<ModalButton
					className="tw-w-full tw-pl-[20px] tw-pr-[20px] sm:tw-pl-[35px] sm:tw-pr-[35px]"
					onPress={() => updateState("Excellent")}
				>
					Excellent
				</ModalButton>
			</div>
		</div>
	);
};

CreditScore.propTypes = {
	setMediaAlphaState: PropTypes.func.isRequired,
	isLastStep: PropTypes.bool.isRequired,
};

export default CreditScore;
